const swiper = new Swiper('.hero-swiper', {
  loop: true,
  navigation: {
    nextEl: '.hero-swiper-button-next',
    prevEl: '.hero-swiper-button-prev',
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: true,
  },
  effect: 'slide',
  speed: 1000
});

document.querySelectorAll('.play-video-button').forEach(button => {
  button.addEventListener('click', function () {
    const wrapper = this.closest('.banner__media');
    const videoWrapper = wrapper.querySelector('.banner__video-wrapper');
    if (videoWrapper) {
      videoWrapper.style.display = 'block';
      swiper.autoplay.stop();
    }
  });
});